/* eslint-disable no-console */
import { ILogger } from '../types';

export const fakeLogger: ILogger = {
  trace: (str) => console.log(str),
  error: (str) => console.error(str),
  info: (str) => console.log(str),
};
